import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as domain from '@common/domain/entities/Organisation';
import * as models from '@common/domain/models/OrganisationDTO';
import { IApiServiceCommand } from '@services/api/api.service';

export class OrganisationEndpoints extends domain.OrganisationEndPoints implements IEntityEndPoints{
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/organisation/" + serviceCommand.context.entityId
    }
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/organisation/update/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
}
export class RoleOrganisationEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {url: app.config.controllerRouteRoot + "/role/organisations",
    //url: app.config.controllerRouteRoot + "/role/getOrganisations/{context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.context.entityId
      }
    }
  };
  insert?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/role/addOrganisation",
    //url: app.config.controllerRouteRoot + "/role/addOrganisation?roleId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      debugger;
      return {
        roleId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/removeOrganisation",
    //url: app.config.controllerRouteRoot + "/role/removeOrganisation?roleId={context.parent.parent.selectedItem.id}&organisationId={data.id}"",
    params: function(serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}
export class RoleOrganisationAllEndPoints implements IEntityEndPoints {
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/Role/addAllOrganisations/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/Role/removeAllOrganisations/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
}

export class UserOrganisationAllEndPoints implements IEntityEndPoints {
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/User/addAllOrganisations/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/User/removeAllOrganisations/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
}
export class UserOrganisationEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/organisations",
    //url: app.config.controllerRouteRoot + "/user/getOrganisations/{context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId
      }
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/addOrganisation",
    //url: app.config.controllerRouteRoot + "/user/addOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/removeOrganisation",
    //url: app.config.controllerRouteRoot + "/user/removeOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}"",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}

export class RoleOrganisationListColumns extends Array<IColumnOptions> {
  public selected: IColumnOptions = { field: "selected", width: "140px" };
  public name: IColumnOptions = { field: "name" };
  constructor() {
    super();
    this.push(this.selected);
    this.push(this.name);
  }
}

export class RoleOrganisationListSetup implements IGridOptions {
  protected roleOrganisationListName: string = "roleOrganisationList";
  protected roleOrganisationListModel: models.OrganisationDTO = new models.OrganisationDTO();
  protected roleOrganisationListEndPoints: domain.OrganisationEndPoints = new domain.OrganisationEndPoints();
  protected roleOrganisationListColumns: RoleOrganisationListColumns = new RoleOrganisationListColumns();
  public organisationForm: OrganisationForm = new OrganisationForm();
  public get name(): string { return this.roleOrganisationListName };
  public get model(): models.OrganisationDTO { return this.roleOrganisationListModel };
  public get endPoints(): IEntityEndPoints { return this.roleOrganisationListEndPoints };
  public set endPoints(organisationEndPoints: IEntityEndPoints) {
    this.roleOrganisationListEndPoints = organisationEndPoints;
    this.organisationForm.endPoints = this.endPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): RoleOrganisationListColumns { return this.roleOrganisationListColumns };
}

export class UserOrganisationListColumns extends domain.OrganisationListColumns {
  public selected: IColumnOptions = { field: "selected", width: "140px" };
  public name: IColumnOptions = { field: "name" };
  constructor() {
    super();
    this.splice(0, this.length);
    this.push(this.selected);
    this.push(this.name);
    this.selected.readOnly = false;
    this.selected.endPoints = new UserOrganisationEndPoints();
    this.selected.selectAllEndPoints = new UserOrganisationAllEndPoints();
  }
}

export class UserOrganisationListSetup implements IGridOptions {
  protected userOrganisationListName: string = "userOrganisationList";
  protected userOrganisationListModel: models.OrganisationDTO = new models.OrganisationDTO();
  protected userOrganisationListEndPoints: domain.OrganisationEndPoints = new domain.OrganisationEndPoints();
  protected userOrganisationListColumns: UserOrganisationListColumns = new UserOrganisationListColumns();
  public organisationForm: OrganisationForm = new OrganisationForm();
  public get name(): string { return this.userOrganisationListName };
  public get model(): models.OrganisationDTO { return this.userOrganisationListModel };
  public get endPoints(): IEntityEndPoints { return this.userOrganisationListEndPoints };
  public set endPoints(organisationEndPoints: IEntityEndPoints) {
    this.userOrganisationListEndPoints = organisationEndPoints;
    this.organisationForm.endPoints = this.endPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): UserOrganisationListColumns { return this.userOrganisationListColumns };
}
export class OrganisationEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation", method: "GET" };
  get?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation/", method: "GET" };
  update?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation/update/", method: "POST" };
  insert?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation/create", method: "POST" };
  delete?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation/delete/", method: "POST" };
}

let organisationListEndPoint: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation", method: "GET" };

export class OrganisationFormFields extends domain.OrganisationFormFields {
  public parentIdD: IFieldOptions = { field: "parentId", dataEndPoint: organisationListEndPoint, dataIdField: "id", dataDisplayField: "name" };
  constructor() {
    super();
    this.splice(0, this.length);
    this.push(this.parentIdD);
    this.push(this.name);
    this.push(this.description);
  }
}


export class OrganisationForm extends domain.OrganisationForm implements IFormOptions {
  public get displayName(): string { return "name" };
  protected organisationFormEndPoints: OrganisationEndpoints = new OrganisationEndpoints();
  protected organisationFormFields: OrganisationFormFields = new OrganisationFormFields();
}


export class RoleOrganisationList extends RoleOrganisationListSetup implements IGridOptions {
  protected roleOrganisationListEndPoints: RoleOrganisationEndPoints = new RoleOrganisationEndPoints();
  protected roleOrganisationListColumns: RoleOrganisationListColumns = new RoleOrganisationListColumns();
}

export class UserOrganisationList extends UserOrganisationListSetup implements IGridOptions {
  protected userOrganisationListEndPoints: UserOrganisationEndPoints = new UserOrganisationEndPoints();
  protected userOrganisationListColumns: UserOrganisationListColumns = new UserOrganisationListColumns();
  public disableNavigation: boolean = true;
}
